import auth from '@/modules/auth'
import menu from '@/modules/menu'
import employees from '@/modules/employees'
import utils from '@/modules/utils'
import ui from '@/modules/ui'
import scales from '@/modules/scales'

export default {
  auth,
  menu,
  employees,
  utils,
  ui,
  scales,
}
